import { useSessions } from "@/hooks/dashboard/useSessions";
import { useAutoRefresh } from "@/hooks/dashboard/useAutoRefresh";
import { SessionsError } from "./SessionsError";
import { SessionsHeader } from "./SessionsHeader";
import { SessionsLoading } from "./SessionsLoading";
import { SessionsPagination } from "./SessionsPagination";
import { SessionsTable } from "./table/SessionsTable";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { useTranslation } from "react-i18next";

export function SessionsSection() {
  const { t } = useTranslation();
  const {
    sessionsResponse,
    error,
    isLoading,
    pageSize,
    statusFilter,
    refetch,
    actions,
  } = useSessions();

  // Use the auto-refresh hook to handle periodic refreshes
  const { refresh } = useAutoRefresh(refetch, { interval: 30000 });

  // Handler for manual refresh button click
  const handleRefresh = () => {
    refresh();
  };

  if (error) {
    return <SessionsError error={error as Error} />;
  }

  // Keep the filter visible even when there's no data
  const hasData = sessionsResponse?.data;

  return (
    <Accordion type="single" collapsible defaultValue="sessions">      <AccordionItem value="sessions" className="flex flex-col gap-2">
      <AccordionTrigger>{t("infoSection.sessions")}</AccordionTrigger>
      <AccordionContent>
        <aside className="space-y-1">
          <SessionsHeader
            statusFilter={statusFilter}
            onStatusChange={actions.setStatusFilter}
            pageSize={pageSize}
            onPageSizeChange={actions.setPageSize}
            onRefresh={handleRefresh}
          />
          {isLoading ? (
            <SessionsLoading />
          ) : hasData && (
            <>
              <SessionsTable data={sessionsResponse.data} onRefresh={actions.refetch} />
              <SessionsPagination
                sessionsResponse={sessionsResponse}
                onPreviousPage={actions.previousPage}
                onNextPage={actions.nextPage}
                onPageChange={actions.goToPage}
              />
            </>
          )}
        </aside>
      </AccordionContent>
    </AccordionItem>
    </Accordion>
  );
}